// ** Redux Imports
import { combineReducers } from 'redux';
import clientReducer from './client.reducer';
import userReducer from './user.reducer';

const adminReducer = combineReducers({
  clientReducer,
  userReducer
});

export default adminReducer;
